<script setup>
import {ref, onMounted} from "vue";
import helpers from "@/lib/helpers";

const props = defineProps({
  inventory: Object,
  usePortal: Boolean
})

const history = ref([])

onMounted(() => {
  helpers.asyncAction(props.inventory._links.location_history_url.href, props.inventory._links.location_history_url.method).then(
      result => history.value = result.map(row => {
        return {
          ...row,
          _showDetails: row.audit && !!row.audit.length
        }
      })
  )
})
</script>

<template>
  <modal height="300px" :title="'Location History ' + inventory.gli" hide-top>
    <div class="mx-2">
      <b-table
          responsive
          details-td-class="pb-1 pt-0 pl-4"
          hover
          :fields="['when', 'user', 'from', 'to']"
          head-variant="light"
          :items="history">

        <template #row-details="row">
          <b-badge pill class="my-1 mr-1" v-for="audit in row.item.audit" :key="audit.id"
                   :variant="audit.good ? 'success' : 'warning'">
            <template v-if="audit.good">
              Count Confirmed {{ audit.created |timediff }} by {{ audit.createdby_user.userid }}
            </template>
            <template v-else-if="audit.under">
              Count MISSING {{ audit.created |timediff }} by {{ audit.createdby_user.userid }}
            </template>
            <template v-else-if="audit.over">
              Count OVER {{ audit.created |timediff }} by {{ audit.createdby_user.userid }}
            </template>
          </b-badge>
        </template>

      </b-table>
    </div>
  </modal>
</template>

<style scoped>

</style>